import { Booking } from '../../models/Booking'
import { Chip } from '../common/fields/Chip'
import { WorkflowIconSection } from './WorkflowIconSection'
import { WorkflowPageCard } from './WorkflowPageCard'

type BookingNotificationsProps = {
    booking: Booking
    onUpdateBooking: (updatedBooking: Booking) => void
}

export const BookingNotificationsSection = ({
    booking,
    onUpdateBooking,
}: BookingNotificationsProps) => {
    return (
        <WorkflowPageCard title="Notifications" defaultIsCollapsed>
            <WorkflowIconSection
                title="Send via"
                icon="messageArrowUp.large"
                description="Choose how you'd like your client to be sent this appointment"
            >
                <div className="flex flex-wrap items-center justify-start gap-2">
                    {Booking.channelStrings().map(({ id, label }, index) => (
                        <Chip
                            key={id ?? label ?? index}
                            title={label ?? ''}
                            isSelected={(booking.channel ?? '') === (id ?? '')}
                            onClick={() => onUpdateBooking(booking.clone({ channel: id }))}
                            size="small"
                        />
                    ))}
                </div>
            </WorkflowIconSection>

            <WorkflowIconSection
                title="Reminder"
                icon="alarmClock.large"
                description="Choose when you'd like your client to receive a reminder ahead of this appointment"
            >
                <div className="flex flex-wrap items-center justify-start gap-2">
                    {Booking.reminderStrings().map(({ id, label }, index) => (
                        <Chip
                            key={id ?? label ?? index}
                            title={label ?? ''}
                            isSelected={(booking.reminder ?? '') === (id ?? '')}
                            onClick={() => onUpdateBooking(booking.clone({ reminder: id }))}
                            size="small"
                        />
                    ))}
                </div>
            </WorkflowIconSection>

            <WorkflowIconSection
                title="Follow-up reminder"
                icon="alarmClock.large"
                description="Send an automated follow-up to remind your client to rebook this appointment"
            >
                <div className="flex flex-wrap items-center justify-start gap-2">
                    {Booking.rebookStrings().map(({ id, label }, index) => (
                        <Chip
                            key={id ?? label ?? index}
                            title={label ?? ''}
                            isSelected={(booking.rebook ?? '') === (id ?? '')}
                            onClick={() => onUpdateBooking(booking.clone({ rebook: id }))}
                            size="small"
                        />
                    ))}
                </div>
            </WorkflowIconSection>
        </WorkflowPageCard>
    )
}
